export default __webpack_public_path__ + "static/loyall-featured-image-website-light-fdc97ad83fe5a0fd6b2a93a78e819e0a.jpg";